<template>
    <Multiselect
        v-model="userGroupTypes" 
        :options="userGroupTypesOptions"
        :multiple="enableCheckbox?true:false"
        track-by="_id"
        :custom-label="userGroupLabelCallback"
        :close-on-select="true"
        :show-no-results="false"
        deselectLabel =""
        selectLabel=""
        selectedLabel=""
        :placeholder="enableCheckbox?'Enter groupname':'Search group'"
        :hideSelected="false"
        :showNoOptions="false"
        @remove="userGroupTypeOnRemove($event)"
        @select="enableCheckbox?userGroupTypeOnSelect($event):optionsOnSelectCallback($event)">
        <div slot="tag" slot-scope="option" class="tags-style">
          <div class="user-name-or-image-in-selected-option"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
                <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                <path fill-rule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"/>
                <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>
                </svg>
            </div>
          <div class="user-name-display user-name-display-as-tags">{{option.option.group_name}}</div>
          <div class="remove-tag" v-on:click="removeSelectedOption(option.option)">
            <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
              </svg>
          </div>
        </div>
        <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
        <input v-if="enableCheckbox" type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeCheckBoxSelection(scope.option)" @focus.prevent :key="scope.option.group_name"/>
        <span style="margin-inline-start:12px;">{{ scope.option.group_name }}</span>
        </div>
        <span slot="noResult">No results</span>
        <span slot="noOptions" style="display:none"></span>
    </Multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import {mapActions} from "vuex";

export default {
      props:["enableCheckbox","selectedUserGroupList","selectedUserGroupIds", "componentUuid"],
      data() {
            return {
                userGroupTypes: [],
                userGroupTypesOptions: [],
                userGroupIdList: []
            }
        },
        components:{
            "Multiselect":Multiselect,
        },
        methods:{
            userGroupLabelCallback(option){
                return `${option.group_name}`
            },
            getAllUserGroupNamesFromServer(){
                this.getAllUserGroupsFromServer().then((data) => {
                    this.userGroupTypesOptions =  data.user_groups;
                });
            },
            userGroupTypeOnSelect(option){
             let index = this.userGroupTypesOptions.findIndex(item => item._id == option._id);
                 if(index > -1){
                     this.userGroupTypesOptions[index].checked = true;
                     this.userGroupIdList.push(option._id)
                     if(this.componentUuid != undefined){
                         this.$emit("updatedUsersGroupsList",option._id,this.componentUuid)
                     }else{
                         this.$emit("updatedUsersGroupsList",option._id)
                     }
                 }
             },
             userGroupTypeOnRemove(option){
                 let index = this.userGroupTypes.findIndex(item => item._id == option._id);
                 if(index > -1){
                     this.userGroupTypes[index].checked = false;
                     this.userGroupIdList = this.userGroupIdList.filter(e => e != option._id)
                     if(this.componentUuid != undefined){
                         this.$emit("removedUserGroupFromList",option._id,this.componentUuid)
                     }else{
                         this.$emit("removedUserGroupFromList",option._id)
                     }
                 }
             },
             makeCheckBoxSelection(option){
                 if((this.selectedUserIdNameMap != undefined && this.userGroupTypes.length) || this.userGroupTypes.length){
                     return this.userGroupTypes.some((op) => op._id === option._id);
                 }
             },
            removeSelectedOption(option){
              let indexOfSelectedOption = this.userGroupTypes.findIndex((e) => e._id == option._id);
              if(indexOfSelectedOption > -1){
                  this.userGroupTypeOnRemove(option);
                  this.userGroupTypes.splice(indexOfSelectedOption,1);
              }
            },
            optionsOnSelectCallback(option){
              this.userGroupTypes = option;
              this.$emit("updatedUsersGroupsList",this.userGroupTypes)
            },
            getSelectedGroupIdsList(){
              return this.userGroupIdList;
            },
            ...mapActions("userGroups", ["getAllUserGroupsFromServer"]),
        },
        created(){
          this.getAllUserGroupNamesFromServer();
            if(this.selectedUserGroupList != undefined && this.selectedUserGroupList.length){
              for(let i=0; i<this.selectedUserGroupList.length; i++){
                if(Object.keys(this.selectedUserGroupList[i]).includes("user_group_id")){
                  this.selectedUserGroupList[i]["_id"] = this.selectedUserGroupList[i]["user_group_id"]
                }
                if(Object.keys(this.selectedUserGroupList[i]).includes("name")){
                  this.selectedUserGroupList[i]["group_name"] = this.selectedUserGroupList[i]["name"]
                }
              }
            }
          this.userGroupTypes = this.selectedUserGroupList;
          Object.assign(this.userGroupIdList, this.selectedUserGroupIds);
        } ,
}
</script>


<style scoped lang="scss">
$header-background: #1a1a1a;
$border-color: 1px solid #3a3a3a;
$background: #121212;
$background-color-on-hover: #141414;
$body-background-color: #141414;
$dull-text-color: #858585;
$options-text-color: #9c9c9c;
$icon-color-on-hover: #9c9c9c;
$text-color: #eee;
$table-row-border: none;
$table-border-color:1px solid #141414;
$active-blue: #007bff;
$danger-color: #dc3545 !important;
$input-field-bg-color: #121212;
$input-field-border-color: #202020;
$input-field-height:38px;
$button-height:38px;
$secondary-border-color: 1px solid #3a3a3a;
$searchBar-border-color: 1px solid #202020;
$secondary-text-color: #bbb;
$modal-border:1px solid #202020;
$modal-background: #121212;
$header-color:#9e9e9e;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#141414;
$scrollbar-thumb-on-hover-background:#555;
$input-field-padding:.375rem 10px;
$input-field-and-label-font-size:14px;
$danger-color: #dc3545 !important;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$breadcrumb-background:#181818;
$mutliselect-tag-bg-color:#121212;
$multiselect-tag-border-color:#292929;
$mutliselect-all-tags-bg-color:#1d1d1d;
$multiselect-option-highlight-bg-color:#242424;
$multiselect-tag-on-focus-or-hover-bg-color:#121212;
$tags-font-size:12px;

.all-users-selection:hover{
  background: $multiselect-tag-on-focus-or-hover-bg-color;
}

.bigger-checkboxes {
    height: 30px;
    width: 20px;
    position:relative;
}
input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block !important;
    width: 22px !important;
    height: 21px !important;
    margin-top: 5px !important;
    margin-inline-start: -1px !important;
    border: $border-color !important;
    border-radius: 0.25em !important;
    background: $body-background-color !important;
}
input[type="checkbox"]:checked:after {
    content: "✔";
    color: $active-blue !important;
    position: absolute !important;
    font-size: 16px !important;
    line-height: 1 !important;
    transition: all 0.2s !important;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px !important;
    padding-top: 2px !important;
}

.user-name-or-image{
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
    margin-inline-end: 5px;
}
::v-deep{
  .multiselect {
    margin: 3px 0px;
  }
  .multiselect__content-wrapper {
    display: none;
  }
  .multiselect__tag, .tags-style {
    background-color: $mutliselect-tag-bg-color !important;
    border: 1px solid $multiselect-tag-border-color;
    border-radius: 5px;
  }
  .multiselect__tags, .tags-style {
    background: $mutliselect-all-tags-bg-color !important;
    border: 1px solid $input-field-border-color !important;
    margin-bottom: 4px;
  }
  .multiselect__option--highlight {
    background: $multiselect-option-highlight-bg-color !important;
  }
  .multiselect__content {
    background: $header-background !important;
  }
  .multiselect__input,
  .multiselect__single {
    background: transparent !important;
    color: $text-color;
  }
  .multiselect__input:focus {
    outline: none;
    box-shadow: none;
  }
  .multiselect__tag-icon {
    color: $text-color !important;
  }
  .multiselect__tag-icon:focus,
  .multiselect__tag-icon:hover {
    background: $multiselect-tag-on-focus-or-hover-bg-color !important;
    color: $text-color !important;
  }
  .multiselect__tag-icon:after {
    color: $icon-color-on-hover !important;
    font-size: 23px;
  }

  .multiselect__tag-icon {
    visibility: hidden;
  }

  .multiselect__tag:hover .multiselect__tag-icon {
    visibility: visible;
  }

  .multiselect * {
    font-size: $input-field-and-label-font-size !important;
    font-family: "Roboto", Arial, sans-serif !important;
  }
  .multiselect__placeholder {
    padding-top: 3px;
    margin-bottom: 0px;
  }
  .multiselect {
    color: $text-color !important;
    font-size: $input-field-and-label-font-size !important;
    width: 40%;
    min-height: 38px;
  }
  .multiselect__single {
    padding-top: 3px;
  }
  .multiselect__option--selected {
    background: $multiselect-option-highlight-bg-color !important;
    color: $text-color;
  }
  .multiselect__content-wrapper {
    border: 1px solid $multiselect-option-highlight-bg-color !important;
    position: absolute;
    display: block;
    background: $text-color;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid $text-color;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 50;
    -webkit-overflow-scrolling: touch;
  }

  .multiselect__current,
  .multiselect__option {
    line-height: 12px !important;
  }

  .multiselect--above .multiselect__content-wrapper {
    background: $header-background !important;
  }
  .multiselect__tags {
    background: $background !important;
    height: auto;
    min-height: 45px;
    padding: 8px 40px 4px 8px;
  }
}

.browse-icon{
    position: relative;
    inset-inline-start:8px;
    top: 3px;
}

.table td, .table th {
    border-top: none;
    padding:0px;
}

.display-as-tags{
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: start;
    float: inline-start;
}

.select-catalog-field{
    width: 101%;
    .value-style{
      width:100%;
    }
}

.user-name-or-image {
  height: 30px;
  width: 30px;
  border: $border-color;
  border-radius: 10px;
  text-align: center;
  line-height: 28px;
  text-transform: uppercase;
  margin-top: 3px;
  margin-inline-start: 5px;
}

.user-name-or-image-in-selected-option{
  border: 1px solid #3a3a3a;
  height: 27px;
  width: 27px;
  border-radius: 5px;
  text-align: center;
  line-height: 26px;
  text-transform: uppercase;
  margin-top: -1px;
  margin-inline-start: -1px;
  }

.tags-style{
    display: inline-flex;
    margin-inline-end: 5px;
    margin-bottom: 5px;
    height: 27px;
    margin-inline-start: 3px;
  .user-name-display-as-tags{
      line-height: 27px;
      margin-inline-start: 6px;
  }
}

.remove-tag{
  color:$dull-text-color;
  line-height: 25px;
}

.remove-tag:hover{
  color:$text-color;
}

</style>